import "reflect-metadata";
import "@jfrog-ba/vue-ui-core/dist/vue-ui-core.css";
import "./assets/styles/css/main.css";
import "@/common-ui/common-ui.css";
import "@jfrog/leapkit-vue3/theme/theme.css";
import "./assets/styles/css/fix-leapkit-palette.css";
import "./assets/styles/css/leapkit-theme-override.css";

import { app } from "./plugins/main-app";
import "./plugins/load-el-plus-icons";
import { pinia } from "@/plugins/pinia.ts";
import "./plugins/eventBus";
import "./plugins/directives";
import "./plugins/firebase";
import "./plugins/jfrog-analytics";
import VueUiCore from "@jfrog-ba/vue-ui-core";
import { commonGlobalsPlugin } from "@/common-ui";
import { trackKeyboardFocusSource } from "@shared/utils/trackKeyboardFocusSource.ts";

trackKeyboardFocusSource();

app.use(VueUiCore);
app.use(commonGlobalsPlugin);

app.use(pinia);
import "./plugins/router";

export default app.mount("#app");
